module.exports = __webpack_public_path__ + "static/img/sp.3cf981f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/binding/img/sp.jpg
// module id = 8QtV
// module chunks = 64